import React from 'react';

import { Icon } from '@/components/icon';
import { Tooltip } from '@/components/tooltip';
import { DATA_IMAGES } from '@/lib/constants/styles';

export const SegmentPredictedMessage = () => {
  return (
    <div
      className="flex items-center justify-between rounded-md bg-green-100 bg-[length:4px] px-3 py-1 text-green-600"
      style={{
        backgroundImage: `url("${DATA_IMAGES.STRIPED_LIGHT}")`,
      }}
    >
      <div className="flex items-center gap-2">
        <Icon name="wand" color="green.600" />
        <p className="mb-0 text-sm leading-snug">
          <b className="font-medium">Predicted service</b> - This service is a schedule prediction based on historical
          tracking data.
        </p>
      </div>
      <Tooltip
        maxWidth="160px"
        className="justify-self-end"
        content="This service prediction is determined using historical live tracking data and predictive algorithms. It may not reflect actual schedules and should only be used as a guide."
      >
        <span>
          <Icon className="[&_path]:fill-green-500" name="question-mark-circled" size={3} />
        </span>
      </Tooltip>
    </div>
  );
};
